import React, { useState } from 'react'
import { TableCellProps } from './TableBodyLineCell.types'
import styles from './TableBodyLineCell.module.scss'
import cl from 'classnames'
import { getTableCellWidth } from 'utilities'

const TableBodyLineCellComponent = (props: TableCellProps) => {
  const {
    className,
    style = {},
    widthPercentage,
    widthPx,
    widthString,
    isColumnMarked,
    hoverComponent,
    children,
    forceHideContent,
    ...cell
  } = props

  const [hover, setHover] = useState(false)

  return (
    <div
      className={cl({
        [styles.clickable]: cell.onClick,
        [styles.markedBackground]: isColumnMarked
        // [styles.positionRelative]: hoverComponent
      }, className)}
      style={{ ...getTableCellWidth(widthPercentage, widthPx, widthString), ...style }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...cell}
    >
      {!forceHideContent && (
        <>
          {children}
          {hover && hoverComponent}
        </>
      )}
    </div>
  )
}

const TableBodyLineCell = TableBodyLineCellComponent
export { TableBodyLineCell }
